/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const getFormattedDateRange = ({
  date,
  useSameYear,
  dateRange,
}: {
  date: Date;
  useSameYear?: boolean;
  dateRange?: number;
}) => {
  if (useSameYear) {
    const year = date.getFullYear();
    const fromDate = `${year}0101`;
    const toDate = `${year}1231`;

    return { fromDate, toDate };
  }

  /**
   * The following few lines are to avoid an edge case where if the current day of the month is larger than the fromDate month,
   * the month rolls over to the next one. For example: March 31st -> February 31st (should be 28th)
   */
  const fromDateFull = new Date(date);
  const normalizedDateRange =
    Number.isFinite(dateRange) && (dateRange as number) > 0 ? Math.floor(dateRange as number) : 12;
  const targetMonth = date.getMonth() - normalizedDateRange;
  fromDateFull.setDate(1);
  fromDateFull.setMonth(targetMonth);
  const lastDayOfTargetMonth = new Date(
    fromDateFull.getFullYear(),
    fromDateFull.getMonth() + 1,
    0,
  ).getDate();
  fromDateFull.setDate(Math.min(date.getDate(), lastDayOfTargetMonth));

  const fromDateYear = fromDateFull.getFullYear();
  const fromDateMonth = fromDateFull.getMonth() + 1;
  const fromDateDay = fromDateFull.getDate();
  const fromDate = `${fromDateYear}${fromDateMonth < 10 ? `0${fromDateMonth}` : fromDateMonth}${fromDateDay < 10 ? `0${fromDateDay}` : fromDateDay}`;

  const toDateYear = date.getFullYear();
  const toDateMonth = date.getMonth() + 1;
  const toDateDay = date.getDate();
  const toDate = `${toDateYear}${toDateMonth < 10 ? `0${toDateMonth}` : toDateMonth}${toDateDay < 10 ? `0${toDateDay}` : toDateDay}`;

  return { fromDate, toDate };
};
